import { render, staticRenderFns } from "./ServiceTable.vue?vue&type=template&id=7be7b202&scoped=true&"
import script from "./ServiceTable.vue?vue&type=script&lang=js&"
export * from "./ServiceTable.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTable.vue?vue&type=style&index=0&id=7be7b202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be7b202",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VImg,VSimpleTable,VSpacer,VSystemBar})
